export default (props, vars) =>
  vars?.['defaultbox145']?.['item']?.['index'] <
  props?.['applicationStatus'].all_steps.length - 1;
